<template>
  <div class="q-pa-md full-height">
    <q-scroll-area style="height: 100%;">
      <div class="row">
        <div class="col-12">
          <div class="area-filtros">
            <div class="area-selecao">
              <q-checkbox :value="isAllSelected()" @input="selectAll()" id="selectAll"></q-checkbox>
              <label for="selectAll" class="label-selecao" @click="selectAll()">SELECIONAR TODOS</label>
            </div>
            <div class="area-buttons">
              <q-btn class="bg-secondary text-white full-height self-center" icon="library_add" @click="mostrarModalAdicionar()">{{ $gettext('ADD') }}</q-btn>
              <q-btn class="bg-secondary text-white full-height self-center botao-selecao" icon="settings_backup_restore"  @click="activateSelected()">{{ $gettext('ACTIVATE') }}</q-btn>
              <q-btn class="bg-secondary text-white full-height self-center botao-selecao" icon="settings_backup_restore" @click="inactivateSelected()">{{ $gettext('INACTIVATE') }}</q-btn>
              <q-btn class="bg-secondary text-white full-height self-center botao-selecao" icon="filter_list" @click="flModalSearch=true">{{ $gettext('SEARCH') }}</q-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="row area-filtros" v-if="mostrarFiltros()">
        <div class="col-12 justify-end q-pa-xs q-gutter-x-sm">
          <div class="filtros-utilizados">
            <div class="self-center q-pr-md">
              <span class="text-bold text-grey-8">
                <span>{{ $gettext('USED_FILTERS') }}</span>:
              </span>
            </div>
            <div :key="index" v-for="(item, index) in listaFiltros()" class="bg-grey-4 q-pl-md rounded-borders lista-filtros">
              <span class="text-bold q-pr-sm">{{ item.name }}</span>
              <span class="q-pr-sm">{{ item.value }}</span>
              <button tabindex="0" @click="removerFiltro(item.name)" type="button" class="q-btn q-btn-item non-selectable no-outline no-padding q-btn--flat q-btn--rectangle text-primary q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active" small="">
                <span class="q-focus-helper"></span>
                <span class="q-btn__wrapper col row q-anchor--skip">
                  <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                    <i aria-hidden="true" role="presentation" class="q-icon notranslate material-icons">close</i>
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <q-list class="rounded-borders" v-if="collectionPoints">
        <div :key="index" v-for="(item, index) in collectionPoints" class="area-ponto-coleta">
          <div class="caixa-selecao">
            <q-checkbox :value="item.selected" @input="handleSelect(index)" class="check-ponto-coleta"></q-checkbox>
          </div>
          <q-expansion-item
            :key="item.id"
            :label="item.name.toUpperCase() + ' - ' + showAreaCode(item)"
            header-class="bg-dark text-white"
            expand-icon-class="text-white"
            class="q-mb-sm collection-points item-flex"
            @click="selectCollectionPoint(index)"
          >
            <q-card>
              <q-card-section class="row card-row" >
                <div class="row col-12 ">
                  <div class="col-4">
                    <label class="text-bold">{{ getLabelDetail("areaCode") }}:</label>
                    {{getValueDetail("areaCode", item)}}
                  </div>
                  <div class="col-4">
                    <label class="text-bold">{{ getLabelDetail("integrationCode") }}:</label>
                    {{getValueDetail("integrationCode", item)}}
                  </div>
                  <div class="col-4">
                    <label class="text-bold">{{ getLabelDetail("available") }}:</label>
                    {{getValueDetail("available", item) ? $gettext('ACTIVE') : $gettext('INACTIVE') }}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="col-4 text-bold">
                    <q-icon name="contacts" size="1.5em" color="negative" class="q-mr-xs"/>
                    <label class="text-bold">{{ getLabelDetail("name") }}:</label>
                    {{getValueDetail("name", item)}}
                  </div>
                  <div class="col-8">
                    <q-icon name="location_on" size="1.5em" color="negative" class="q-mr-xs"/>
                    {{getAddress(item)}}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="col-8">
                    <label class="text-bold">{{ getLabelDetail("companyName") }}:</label>
                    {{getValueDetail("companyName", item)}}
                  </div>
                  <div class="col-4">
                    <label class="text-bold">{{ getLabelDetail("document") }}:</label>
                    {{getValueDetail("document", item)}}
                  </div>
                </div>
                <div class="row col-12">
                  <!-- <div class="col-4">
                    <label class="text-bold">{{ getLabelDetail("location") }}:</label>
                    {{getValueDetail("location", item)}}
                  </div> -->
                  <div class="col-4">
                    <label class="text-bold">{{ getLabelDetail("organizationalStructure") }}:</label>
                    {{getValueDetail("organizationalStructure", item)}}
                  </div>
                </div>
                <div class="row col-12">
                  <label class="text-bold">{{ getLabelDetail("phone") }}:</label>
                    {{ getPhones(item) }}
                </div>
                <div class="row col-12 item-conta" v-if="item.industryAccountForm">
                  <label class="text-bold">Contas do Ponto de Coleta:</label>
                  <jt-dynamic-form
                    :id="'form-industry-'+item.id"
                    :ref="'dynamicForm-'+item.id"
                    :inputs="item.industryAccountForm[0].inputs"
                    :relacionamentos="item.industryAccountForm[0].relacionamentos"
                    :model="item.industryAccountForm[0].dadosForm"
                    :interface="item.industryAccountForm[0].nmInterface"
                    form-class="form dynamic"
                    class="balanceForm"
                    @on-select-change="onSelectChange(item, $event)"
                  />
                </div>
              </q-card-section>
            </q-card>
          </q-expansion-item>
          <div class="label-ativo-inativo">
            <span>{{ $gettext('ACTIVE') }}: <span :class="item.available ? 'item-ativo' : 'item-inativo'">{{  item.available ? $gettext('YES') : $gettext('NO')  }}</span></span>
          </div>
          <div class="area-botao-linha">
            <q-btn flat @click="editCollectionPoint(index)">
              <q-icon name="border_color"
                    size="1.2em" />
              <q-tooltip
                anchor="bottom middle"
                self="top middle"
                content-style="font-size: 13px"
                :offset="[5, 5]"
              >
              {{ $gettext('EDIT') }}
              </q-tooltip>
            </q-btn>
            <q-btn flat @click="activateInactivateCollectionPoint(index)">
              <q-icon name="settings_backup_restore"
                    size="1.2em" />
              <q-tooltip
                anchor="bottom middle"
                self="top middle"
                content-style="font-size: 13px"
                :offset="[5, 5]"
              >
                {{ item.available ? $gettext('INACTIVE') : $gettext('ACTIVE') }}
              </q-tooltip>
            </q-btn>
          </div>
        </div>
      </q-list>
      <jt-empty-message v-else :message="$gettext('NO_COLLECTION_POINTS')" size="10em" />
      <div class="pagination-panel">
        <div class="pagination-area">
          <div class="pagination-item">
            <span class="label-page-size">{{ $gettext('REGISTERS_PER_PAGE') }}:</span>
            <q-select borderless v-model="pageSize" :value="pageSize" :options="options" @input="changePageSize()" />
          </div>
          <div class="pagination-item">
            <span>{{ getActualPage() }}-{{ countPages() }} {{ $gettext('OF') }} {{ totalElements }}</span>
          </div>
          <div class="pagination-item">
            <q-btn round flat @click="goToPage(0)">
              <q-icon name="first_page"
                      size="1.5em" />
            </q-btn>
            <q-btn round flat @click="goToPage(actualPage - 1)">
              <q-icon name="chevron_left"
                      size="1.5em" />
            </q-btn>
            <q-btn round flat @click="goToPage(actualPage + 1)">
              <q-icon name="chevron_right"
                      size="1.5em" />
            </q-btn>
            <q-btn round flat @click="goToPage(calculateTotalPage() - 1)">
              <q-icon name="last_page"
                      size="1.5em" />
            </q-btn>
          </div>
        </div>
      </div>
    </q-scroll-area>
    <q-dialog v-if="flModalSearch" v-model="flModalSearch" maximized>
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{
              $gettext("CONTRACT_SERVICE")
              }}</q-toolbar-title>
            <q-btn @click="flModalSearch = false" flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <q-page-container class="card-container-modal">
          <CollectionPointSearchPage @pesquisar="initSearch($event)"></CollectionPointSearchPage>
        </q-page-container>
      </q-layout>
    </q-dialog>
    <q-dialog v-if="flModalAlterar" v-model="flModalAlterar">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ $gettext('COLLECTION_POINT') }}</q-toolbar-title>
            <q-btn @click="flModalAlterar = false" flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <q-page-container class="card-container-modal">
          <CollectionPointRegisterForm :client="client" :clientId="clientId" :collectionPointId="selectedCollectionPointId" :nmInterface="'collectionPoint.alterarPorCliente'" :updateCollectionPoint="updateCollectionPoint" @confirm="addCollectionPoint($event)" @savingUpdateCollectionPoint="savingUpdateCollectionPoint" @confirmarSalvar="confirmarSalvar()"></CollectionPointRegisterForm>
        </q-page-container>
      </q-layout>
    </q-dialog>
    <q-dialog v-if="flModalAdicionar" v-model="flModalAdicionar">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ $gettext('COLLECTION_POINT') }}</q-toolbar-title>
            <q-btn @click="flModalAdicionar = false" flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <q-page-container class="card-container-modal">
          <CollectionPointRegisterForm :client="client" :clientId="clientId" :nmInterface="'collectionPoint.novoPorCliente'" :saveNewOnConfirm="true" :showReplicateData="false" :updateCollectionPoint="updateCollectionPoint" @confirm="addCollectionPoint($event)" @savingUpdateCollectionPoint="savingUpdateCollectionPoint" @confirmarSalvar="confirmarSalvar()"></CollectionPointRegisterForm>
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtEmptyMessage, JtDynamicForm } from 'jtech-webcomps'
const { page } = JtCrud
import { repository, messageBox } from 'jtech'
import CollectionPointSearchPage from './CollectionPointSearchPage'
import CollectionPointRegisterForm from './CollectionPointRegisterFormPage'

@Component({
  mixins: [page],
  name: 'CollectionPointPage',
  components: {
    JtEmptyMessage,
    JtDynamicForm,
    CollectionPointSearchPage,
    CollectionPointRegisterForm
  },
  props: {
    client: {},
    clientId: {}
  }
})
class CollectionPointPage extends Vue {
  collectionPoints = [];
  inputs = [];
  industryAccountForm = null;
  flModalSearch = false;
  flModalAlterar = false;
  flModalAdicionar = false;
  updateCollectionPoint = null;
  selectedCollectionPointId = null;
  actualPage = 0;
  totalElements = 0;
  unfilteredTotalCount = 0;
  pageSize = '15';
  options = ['5', '10', '15', '50', '100', '500', 'Todos'];
  TODOS = 'Todos';
  filtro = {
    name: null,
    areaCode: null,
    available: null
  };

  async beforeMount () {
    this.initListCollectionPoint()
  }

  async initListCollectionPoint () {
    this.filter(this.filtro)
    this.collectionPoints.forEach(item => {
      item.industryAccountForm = null
      item.selected = false
    })
    this.inputs = this.forms[0].inputs[0].columns
  }

  async getCollectionPoints () {
    const formulario = await repository.resolve('collectionPoint.detalharPorCliente', {
      idAcaoGrid: this.clientId,
      id: this.clientId,
      limit: this.unfilteredTotalCount
    })
    return formulario[0].relacionamentos.collectionPoints
  }

  initSearch (collectionPointFilter) {
    this.actualPage = 0
    this.filter(collectionPointFilter)
  }

  async filter (collectionPointFilter) {
    this.filtro = collectionPointFilter
    const formulario = await repository.resolveDatatableModel('collectionPoint.hql',
      {
        grid: 'filter',
        id: this.clientId,
        idAcaoGrid: this.clientId,
        client: this.clientId,
        name: collectionPointFilter.name,
        areaCode: collectionPointFilter.areaCode,
        available: collectionPointFilter.available,
        limit: this.pageSize !== this.TODOS ? this.pageSize : this.totalElements,
        page: this.actualPage + 1
      })

    if (this.unfilteredTotalCount === 0) {
      this.unfilteredTotalCount = formulario.totalCount
    }

    this.collectionPoints = formulario.registros
    this.totalElements = formulario.totalCount
    this.collectionPoints.forEach(item => {
      item.industryAccountForm = null
      item.selected = false
    })
    this.flModalSearch = false
  }

  getLabelDetail (name) {
    return this.inputs.find(x => x.field === name).label
  }

  getValueDetail (atribute, object) {
    return (object[atribute] ? object[atribute] : '')
  }

  showAreaCode (item) {
    return (item.areaCode = item.areaCode ? item.areaCode : this.$gettext('NO_AREA_CODE').toUpperCase())
  }

  getPhones (object) {
    const phone = this.getValueDetail('phone', object)
    const phoneAlternative = this.getValueDetail('phoneAlternative', object)
    if (phone && phoneAlternative) {
      return `${phone} - ${phoneAlternative}`
    } else if (phone) {
      return phone
    } else if (phoneAlternative) {
      return phoneAlternative
    }
    return ''
  }

  getAddress (object) {
    return `${this.getValueDetail('addressName', object)} - 
    ${this.getValueDetail('addressNumber', object)} -
    ${this.getValueDetail('addressDetail', object)} - 
    CEP: ${this.getValueDetail('addressZipCode', object)} `
  }

  async selectCollectionPoint (index) {
    this.collectionPoints[index].industryAccountForm = await repository.resolve('collectionPoint.industryAccount', { id: this.collectionPoints[index].id })
    this.$forceUpdate()
  }

  async onSelectChange (collectionPoint, event) {
    await repository.resolveLogic('collectionPoint.saveIndustryAccounts', { id: collectionPoint.id, industryAccount: event.selectedValue })
  }

  handleSelect (index) {
    this.collectionPoints[index].selected = !this.collectionPoints[index].selected
    this.$forceUpdate()
  }

  isAllSelected () {
    return !this.collectionPoints.some(item => !item.selected)
  }

  selectAll () {
    const valueSelect = !this.isAllSelected()
    this.collectionPoints.forEach(item => { item.selected = valueSelect })
    this.$forceUpdate()
  }

  async editCollectionPoint (index) {
    this.$q.loading.show({ message: this.$gettext('LOADING_MESSAGE') })
    try {
      const idToEdit = this.collectionPoints[index].id
      this.selectedCollectionPointId = idToEdit
      const listaDetalhada = await this.getCollectionPoints()

      const fullData = listaDetalhada.find(ponto => ponto.id === idToEdit)

      if (!fullData) {
        throw new Error('Data not found for the item.')
      }

      this.updateCollectionPoint = {
        ...fullData,
        index: index,
        addressNeighborhood: fullData.neighborhoodName,
        municipalRegistration: fullData.city,
        stateRegistration: fullData.state,
        addressId: fullData.addressId
      }

      this.flModalAlterar = true
      this.$q.loading.hide()
    } catch (error) {
      this.$q.loading.hide()
      console.error('Failed to fetch collection point details:', error)
    }
  }

  mostrarModalAdicionar () {
    this.flModalAdicionar = true
  }

  async inactivateSelected () {
    if (!this.collectionPoints.some(item => item.selected)) {
      messageBox.error(this.$gettext('NO_COLLETION_POINTS_SELECTED'))
      return
    }

    const idsToInactivate = this.collectionPoints.filter(item => item.selected).map(item => item.id)
    messageBox.success(this.$gettext('COLLETION_POINTS_SAVED'))
    await repository.resolveLogic('collectionPoint.inativarPorIds', { ids: idsToInactivate })
    this.filter(this.filtro)
  }

  async activateSelected () {
    if (!this.collectionPoints.some(item => item.selected)) {
      messageBox.error(this.$gettext('NO_COLLETION_POINTS_SELECTED'))
      return
    }

    const idsToActivate = this.collectionPoints.filter(item => item.selected).map(item => item.id)
    messageBox.success(this.$gettext('COLLETION_POINTS_SAVED'))
    await repository.resolveLogic('collectionPoint.ativarPorIds', { ids: idsToActivate })
    this.filter(this.filtro)
  }

  mostrarFiltros () {
    if (!this.filtro) {
      return false
    }
    if (!this.filtro.name && !this.filtro.areaCode && (this.filtro.available == null || this.filtro.available == undefined)) {
      return false
    }

    return true
  }

  listaFiltros () {
    const lista = []
    if (!this.filtro) {
      return []
    }
    if (this.filtro.name) {
      lista.push({
        name: this.$gettext('NAME'),
        value: this.filtro.name
      })
    }
    if (this.filtro.areaCode) {
      lista.push({
        name: this.$gettext('AREA_CODE'),
        value: this.filtro.areaCode
      })
    }
    if (this.filtro.available != null && this.filtro.available != undefined) {
      lista.push({
        name: this.$gettext('ACTIVE'),
        value: this.filtro.available ? this.$gettext('YES') : this.$gettext('NO')
      })
    }

    return lista
  }

  removerFiltro (nomeFiltro) {
    if (nomeFiltro === this.$gettext('NAME')) {
      this.filtro.name = null
    }
    if (nomeFiltro === this.$gettext('AREA_CODE')) {
      this.filtro.areaCode = null
    }
    if (nomeFiltro === this.$gettext('ACTIVE')) {
      this.filtro.available = null
    }
    this.actualPage = 0
    this.filter(this.filtro)
  }

  confirmarSalvar () {
    this.flModalAdicionar = false
    this.flModalAlterar = false
    this.initListCollectionPoint()
  }

  async activateInactivateCollectionPoint (index) {
    if (this.collectionPoints[index].available) {
      await repository.resolveLogic('collectionPoint.inativarPorIds', { ids: [this.collectionPoints[index].id] })
    } else {
      await repository.resolveLogic('collectionPoint.ativarPorIds', { ids: [this.collectionPoints[index].id] })
    }
    messageBox.success(this.$gettext('COLLETION_POINTS_SAVED'))
    this.filter(this.filtro)
  }

  countPages () {
    const result = (this.actualPage + 1) * this.pageSize
    if (this.pageSize === this.TODOS || result > this.totalElements) {
      return this.totalElements
    }
    return result
  }

  goToPage (pagina) {
    if (pagina >= this.calculateTotalPage() || pagina < 0 || this.pageSize === this.TODOS) {
      return
    }

    this.actualPage = pagina
    this.filter(this.filtro)
  }

  calculateTotalPage () {
    return Math.ceil(this.totalElements / this.pageSize)
  }

  changePageSize () {
    this.actualPage = 0
    this.filter(this.filtro)
  }

  getActualPage () {
    if (this.pageSize !== this.TODOS) {
      return ((this.actualPage) * this.pageSize) + 1
    } else {
      return 1
    }
  }
}
export default CollectionPointPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.collection-points{
  .q-item{
    min-height: 42px!important;
    border-radius: 3px;
  }
}

.card-row > div {
  padding: 5px 10px;
}

.card-row > div:nth-child(odd) {
  background-color: $ice;
}
.item-ativo {
  color: green
  font-weight: bold
}
.item-inativo {
  color: red
  font-weight: bold
}
.area-buttons {
  padding: 20px;
  text-align: right;
}
.area-filtros {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.area-selecao {
  display: flex;
  align-items: center;
}
.label-selecao {
  cursor: pointer;
}
.botao-selecao {
  margin-left: 10px;
}
.area-filtros {
  margin-bottom: 30px;
}
.filtros-utilizados {
  display: flex;
  justify-content: end;
}
.lista-filtros {
  margin-right: 8px;
}
.area-ponto-coleta {
  display: flex
}
.caixa-selecao {
  display: contents;
}
.check-ponto-coleta {
  height: 50px;
}
.item-flex {
  flex: 1;
}
.item-conta {
  height: 100px;
}
.label-ativo-inativo {
  position: absolute;
  right: 0;
  margin-right: 160px;
  margin-top: 12px;
  color: white;
  cursor: pointer;
  z-index: 1000;
}
.area-botao-linha {
  position: absolute;
  right: 0;
  margin-right: 50px;
  margin-top: 5px;
  color: white;
  cursor: pointer;
  z-index: 1000;
}
.pagination-panel {
  width: 100%;
  height: 56px;
  background: #eceff1;
  border-top: 1px solid #cfd2d4;
  border-bottom: 1px solid #cfd2d4;
}
.pagination-area {
  display: flex;
  justify-content: end;
}
.pagination-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.label-page-size {
  margin-right: 20px;
}
</style>
